module.exports = __webpack_public_path__ + "static/media/service-block-6@4x.f9ef4763.jpg";